import { AfterViewInit,Component,ElementRef,Inject,Input,LOCALE_ID,OnDestroy,OnInit,TemplateRef,ViewChild } from '@angular/core';
import { FormControl,FormGroup,Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute,ResolveData } from '@angular/router';
import { GetTimestampFromTime } from '@dave/types';
import { Store } from '@ngrx/store';
import { isArray } from 'chart.js/helpers';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable,of,Subject,Subscription } from 'rxjs';
import {
    distinctUntilChanged,
    filter,
    first,
    map,
    shareReplay,
    skip,
    startWith,
    switchMap,
    take,
    takeUntil, tap,
    withLatestFrom,
} from 'rxjs/operators';
import { CommissionActionTypes } from 'src/app/dave-data-module/State/actions/commission.actions';
import { AppConfirmationDialogComponent,AppConfirmationDialogData } from 'src/app/dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import { IDetailListTemplateData } from 'src/app/dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { CommentListDialogComponent,CommentListDialogComponentDialogData } from '../../../dave-comments/components/comment-list-dialog/comment-list-dialog.component';
import { CommentEntityTypeEnum } from '../../../dave-data-module/entities/comment.entity';
import { EntityRoleEntity, EntityTypesEnum } from '../../../dave-data-module/entities/entity-role.entity';
import { PartnerTypeEnum } from '../../../dave-data-module/entities/partner.entity';
import { CommentResolver } from '../../../dave-data-module/guards/comment.resolver';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { CommissionTypeResolver } from '../../../dave-data-module/guards/commissionType.resolver';
import { EntityRoleResolver } from '../../../dave-data-module/guards/entity-role.resolver';
import { PartnerOfficeResolver } from '../../../dave-data-module/guards/partner-office.resolver';
import { StatusFromBackofficeResolver } from '../../../dave-data-module/guards/statusFromBackoffice.resolver';
import { TokenResolver } from '../../../dave-data-module/guards/token.resolver';
import { UserToCommissionResolver } from '../../../dave-data-module/guards/user-to-commission.resolver';
import { UserResolver } from '../../../dave-data-module/guards/user.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { AppGatewayService } from '../../../dave-data-module/services/app-gateway.service';
import { State } from '../../../dave-data-module/State';
import { ChangeSettings } from '../../../dave-data-module/State/actions/settings.actions';
import { commissionsFeatureKey } from '../../../dave-data-module/State/reducers/commission.reducer';
import { CommissionTypesFeatureKey } from '../../../dave-data-module/State/reducers/commissionType.reducer';
import { ENTITY_ROLE_KEY } from '../../../dave-data-module/State/reducers/entity-role.reducer';
import { StatusFromBackofficeFeatureKey } from '../../../dave-data-module/State/reducers/statusFromBackoffice.reducer';
import { USER_TO_COMMISSION_KEY } from '../../../dave-data-module/State/reducers/user-to-commission.reducer';
import { usersFeatureKey } from '../../../dave-data-module/State/reducers/users.reducer';
import { getCommentFetched } from '../../../dave-data-module/State/selectors/comment.selector';
import {
    getCommissionById,
    getCommissionDictionary,
} from '../../../dave-data-module/State/selectors/commission.selector';
import { getCommissionTypeById,getCommissionTypes } from '../../../dave-data-module/State/selectors/commissionType.selectors';
import { getEmployeesActiveSortedByNameStartWithMe } from '../../../dave-data-module/State/selectors/employees.selectors';
import { getEntityRole,getEntityRoleFetched } from '../../../dave-data-module/State/selectors/entity-role.selector';
import { getOwnPartnerOffices,getPartner,getPartnerFetched } from '../../../dave-data-module/State/selectors/partners.selectors';
import { getStatusFromBackoffice } from '../../../dave-data-module/State/selectors/statusFromBackoffice.selectors';
import { getSetting,getSettingFetched } from '../../../dave-data-module/State/selectors/users.selectors';
import {
DaveFilePreviewComponent,
DaveFilePreviewComponentDialogData
} from '../../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import { DaveListComponent,MultiselectButton } from '../../../dave-list/components/dave-list/dave-list.component';
import { PieceworkDemoComponent } from '../../../dave-piecework-calculation/components/piecework-demo/piecework-demo.component';
import { SelectUserCommissionDialogComponent,SelectUserCommissionDialogComponentDialogData } from '../../../dave-select-user/components/select-user-dialogs/select-user-commission-dialog/select-user-commission-dialog.component';
import {
    FilterOption, FILTER_TYPE_BOOLEAN, FILTER_TYPE_SEARCH_MULTI_SELECT, IFilterTypeSearchMultiSelectValue,
    FilterOptionSelectSearch, FILTER_TYPE_SEARCH_SELECT_BACKEND
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { PermissionService } from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import {
compareArrays,isNotNullOrUndefined,TableColumnConfig
} from '../../../helper/helper';
import { CommentIcon,CommissionMeta } from '../../../helper/page-metadata';
import { NewCommissionDialogComponent,NewCommissionDialogComponentDialogData } from '../../../new-commission-dialog/new-commission-dialog.component';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { DefaultFilterService,FilterApps,FilterTypes } from '../../../services/default-filter.service';
import { DefaultTableSortingService } from '../../../services/default-table-sorting.service';
import { LoadingService } from '../../../services/loading.service';
import {
CommissionCsvExportDialogComponent,CommissionCsvExportDialogData,CommissionCsvExportDialogReturnData
} from '../commission-csv-export-dialog/commission-csv-export-dialog.component';
import { CommissionDownloadComponent } from '../commission-download/commission-download.component';
import { CommissionListDataSource,CommissionListItem } from './commission-list-datasource';
import { CommissionWizardDialogService } from '../../../services/commission-wizard-dialog.service';
import { DEPARTMENT_FEATURE_KEY } from '../../../dave-data-module/State/reducers/department.reducer';
import { DepartmentResolver } from '../../../dave-data-module/guards/department.resolver';
import { personsFeatureKey } from '../../../dave-data-module/State/reducers/person.reducer';
import { PersonResolver } from '../../../dave-data-module/guards/person.resolver';
import { getDepartmentsActive } from '../../../dave-data-module/State/selectors/department.selector';
import { PersonTypeResolver } from '../../../dave-data-module/guards/personType.resolver';
import { personTypesFeatureKey } from '../../../dave-data-module/State/reducers/personType.reducer';
import { ManageUserListResolver } from '../../../dave-data-module/guards/manage-user-list.resolver';
import {CommissionEntity} from "../../../dave-data-module/entities/commission.entity";
import { CustomizationDataService } from '../../../dave-data-module/services/customization-data.service';
import { StatusFromBackofficeNames } from '../../../dave-data-module/entities/statusFromBackoffice.entity';
import {
    getUserToCommissions
} from '../../../dave-data-module/State/selectors/user-to-commission.selector';
import { UserToCommissionEntity } from '../../../dave-data-module/entities/user-to-commission.entity';
import {
    KaplStatus4DialogComponent,
    MissingCommissionValuesDialogData, MissingCommissionValuesResult,
} from '../kapl-status4-dialog/kapl-status4-dialog.component';
import { UserToCommissionActionTypes } from '../../../dave-data-module/State/actions/user-to-commission.action';
import {CustomerDataService} from '../../../dave-data-module/services/customer-data.service';
import {CustomerEntity} from '../../../dave-data-module/entities/customer.entity';
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {Sort} from "@angular/material/sort";
import {LedgerImportDataService} from "../../../dave-data-module/services/ledger-import-data.service";

/**
 * die stehen auch im additionalData vom partner
 */
export type CommissionListColumn =
    | 'InterneNr'
    | 'AuftragsNr'
    | 'SchadenNr'
    | 'VersicherungsNr'
    | 'Projektleiter'
    | 'Vorarbeiter'
    | 'StatusBackoffice'
    | 'Auftraggeber'
    | 'LastDeadline'
    | 'AbgabeterminAG'
    | 'StartDate'
    | 'EndDate'
    | 'Address'
    | 'Sachbearbeiter'
    | 'Auftragstyp'
    | 'Description'
    | 'Author'
    | 'CreatedAt'
    | 'lastComment'
    | 'offerSum'
    | 'freeTextField1'
    | 'OfferSubmissionDate'
    | 'NegotiationAt'
    | 'Department'
    | 'ChildCommissionDepartments'
    | 'PartnerOffice'
    | 'CostCenter'
    | 'CompleteBusinessVolume'
    ;



interface TableData extends CommissionListItem {}
@Component({
    selector: 'app-commission-list',
    templateUrl: './commission-list.component.html',
    styleUrls: ['./commission-list.component.scss'],
})
export class CommissionListComponent implements OnInit, OnDestroy, AfterViewInit {
    public static readonly RequiredResolvers: ResolveData = {
        token: TokenResolver,
        [CommissionTypesFeatureKey]: CommissionTypeResolver,
       // [customersFeatureKey]: CustomerResolver,
       //  [officeFeatureKey]: OfficeResolver,
        [commissionsFeatureKey]: CommissionResolver,
        [StatusFromBackofficeFeatureKey]: StatusFromBackofficeResolver,
        [usersFeatureKey]: UserResolver,
        partnerOffices: PartnerOfficeResolver,
        [USER_TO_COMMISSION_KEY]: UserToCommissionResolver,
        [ENTITY_ROLE_KEY]: EntityRoleResolver,
        [DEPARTMENT_FEATURE_KEY]: DepartmentResolver,
        [personsFeatureKey]: PersonResolver,
        [personTypesFeatureKey]: PersonTypeResolver,
        manageUserList: ManageUserListResolver,
    };
    @ViewChild('lastCommentCell') protected lastCommentTemplate: TemplateRef<any>;
    @ViewChild('offerSumCell') protected offerSumTemplate: TemplateRef<any>;
    @ViewChild('roleCell') protected roleTemplate: TemplateRef<any>;
    @ViewChild('hasChildCell') protected hasChildTemplate: TemplateRef<any>;

    @Input() CommissionExportButton = true;
    @Input() NewCommissionButton = true;
    @Input() AkkordDemoButton = false;

    private subscriptions: Subscription[] = [];

    protected datasource: CommissionListDataSource;
    public DataSource$: Observable<CommissionListDataSource>;

    public FilterSettings$: Observable<FilterOption[]> = combineLatest([
        this.store.select(getEmployeesActiveSortedByNameStartWithMe),
        this.store.select(getOwnPartnerOffices),
        this.store.select(getStatusFromBackoffice),
        this.store.select(getCommissionTypes),
        this.store.select(getPartner),
        this.cls.getSingle$('CustomerSupplier'),
        this.cls.getLabels$('Commission'),
        this.cls.getMultiple$('ExecutingDepartment'),
        this.store.select(getDepartmentsActive),
    ]).pipe(
        map(([employees, partners, statuses, commissionTypes, partner, customerLable, commissionLabels, departmentLabel, departments]) => {
            let commissionTypeValues: IFilterTypeSearchMultiSelectValue[] = commissionTypes
                .filter((ct) => !ct.PartnerSpecificationTypeId || ct.PartnerSpecificationTypeId === partner?.PartnerSpecificationTypeId)
                .filter((c) => !partner.Settings?.hiddenDefaultCommissionTypes?.includes(c.Id))
                .map((ct) => ({
                    label: ct.Name,
                    id: ct.Id,
                }));

            let userValues: IFilterTypeSearchMultiSelectValue[] = employees
                .filter((e) => !!e.UserId)
                .map((e) => ({
                    label: e.DisplayName,
                    id: e.UserId,
                }));

            let partnerValues: IFilterTypeSearchMultiSelectValue[] = partners.map((partner) => ({
                label: partner.DisplayName,
                id: partner.Id,
            }));
            const statusValues: IFilterTypeSearchMultiSelectValue<string>[] = statuses.reduce((arr, status) => {
                const i = arr.findIndex((a) => a.label === status.Name);
                if (i > -1) {
                    arr[i] = { ...arr[i], id: arr[i] + '|' + status.Id };
                } else {
                    arr.push({ label: status.Name, id: status.Id + '' });
                }
                return arr;
            }, [] as IFilterTypeSearchMultiSelectValue<string>[]);

            let customerState = this.customerDataService.createSearchState();

            const ret: FilterOption[] = [
                {
                    Name: FilterTypes.Customers,
                    Type: FILTER_TYPE_SEARCH_SELECT_BACKEND,
                    Label: customerLable,
                    SelectSearch: {
                        options$: customerState.customerOptions$,
                        loading$: customerState.loading$,
                        pageIndex$:  customerState.customerPaging.pageIndex$,
                        pageCount$: customerState.customerPaging.pageCount$,

                        getIdFromValue: (c) => c.Id,
                        getValueFromId: (id) => this.customerDataService.GetSingleCustomer$(id),

                        serverSearch: (search) => customerState.SearchCustomers(search, 'unbenannter ' + customerLable),
                        pageChange: (event) => customerState.customerPageChange(event),
                        compareOptions: (a, b) => a?.Id === b?.Id,
                    } as FilterOptionSelectSearch<CustomerEntity>,
                },
                {
                    Name: FilterTypes.CommissionType,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: commissionLabels.wordBinding + 'art',
                    Values: commissionTypeValues,
                },
                {
                    Name: FilterTypes.Editor,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Bearbeiter',
                    Icon: 'user',
                    Values: userValues,
                },
                {
                    Name: FilterTypes.HideSubCommissions,
                    Type: FILTER_TYPE_BOOLEAN,
                    Label: 'Teilprojekte ausblenden',
                    // Icon: 'user',
                },
                {
                    Name: FilterTypes.HasRelevantRoleOrIsAssigned,
                    Type: FILTER_TYPE_BOOLEAN,
                    Label: 'Nur Zugeordnete ' + commissionLabels.Nominativ.plural.value + ' anzeigen',
                    // Icon: 'user',
                },
            ];
            if (partners?.length > 1) {
                ret.push({
                    Name: FilterTypes.PartnerOfficeId,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Unternehmen',
                    Icon: 'building',
                    Values: partnerValues,
                });
            }
            ret.push(
                {
                    Name: FilterTypes.Departments,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: departmentLabel,
                    // Icon: 'user',
                    Values: departments.map<IFilterTypeSearchMultiSelectValue<number>>(dp => ({id: dp.Id, label: dp.Name})),
                },
                {
                    Name: FilterTypes.Status,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Status',
                    Icon: 'check',
                    Values: statusValues,
                });
            return ret;
        }),
    )

    protected canGetLedgerImports$ = this.PS.Has$(this.PS.Permissions.GetLedgerImports);

    commissionEntityRoles$ = this.store.select(getEntityRoleFetched).pipe(
        filter((v) => v),
        switchMap(() => this.store.select(getEntityRole)),
        map((roles) => roles.filter((r) => r.Entity === EntityTypesEnum.Commission)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    // cls.getSingle$('Commission')
    // TableColumns in TableColumns$ bestimmt, um Header mit CustomLabelService zu bestimmen
    /*
    public TableColumns: TableColumnConfig<TableData, CommissionListColumn>[] = [
        { header: 'InterneNr', name: 'InterneNr', width: '7rem' },
        { header: 'AuftragsNr', name: 'AuftragsNr', width: '9rem' },
        { header: 'SchadenNr', name: 'SchadenNr', width: '7rem' },
        { header: 'VersicherungsNr', name: 'VersicherungsNr', width: '' },
        // { header: 'Verantwortlich', name: 'Bearbeiter', width: '7rem' },
        { header: 'Auftraggeber', name: 'Auftraggeber', width: '12rem' },
        { header: 'Frist', name: 'LastDeadline', width: '5rem' },
        { header: 'AG', name: 'AbgabeterminAG', width: '5rem' },
        { header: 'Status', name: 'StatusBackoffice', width: '8rem' },
        { header: 'Start', name: 'StartDate', width: '5rem' },
        { header: 'Ende', name: 'EndDate', width: '5rem' },
        { header: 'Adresse', name: 'Address', width: '14rem' },
        { header: this.CNS.getName, name: 'Sache', width: '14rem' },
        { header: 'Auftragstyp', name: 'Auftragstyp', width: '14rem' },
        { header: 'Bezeichnung', name: 'Description', width: '14rem' },
        { header: 'Autor', name: 'Author', width: '12rem' },
        { header: 'Erstellt', name: 'CreatedAt', width: '5rem' },
        { header: 'Kommentar', name: 'lastComment', width: '14rem' },
        { header: 'Angebotssumme', name: 'offerSum', width: '10rem' },
        { header: 'Alg. Infos', name: 'freeTextField1', width: '10rem' },
    ];
    */
    private afterViewInit$ = new Subject<void>();
    protected customCellTemplates$ = combineLatest([
        this.commissionEntityRoles$,
        this.afterViewInit$
    ]).pipe(
        map(([roles, _]) => roles),
        startWith([] as EntityRoleEntity[]),//für den fall das die rollen lange brauchen und das template vorher gerendert wird darf CustomCellTemplates an der dave-list nicht null sein
        map((roles) => {
            const roleCols: { [key: string]: TemplateRef<any> } = {};
            roles.forEach((r) => {
                roleCols[CommissionListDataSource.roleKeyPrefix + r.Id] = this.roleTemplate;
            });
            return <{ [key: string]: TemplateRef<any> }>{
                lastComment: this.lastCommentTemplate,
                offerSum: this.offerSumTemplate,
                AuftragsNr: this.hasChildTemplate,
                ...roleCols,
            };
        }),
        tap((ta) => console.log('### customcelltemplates', ta)),
    );
    TableColumns$: Observable<TableColumnConfig<TableData, CommissionListColumn | string>[]> = combineLatest([
        this.commissionEntityRoles$,
        this.cls.getLabels$('Commission'),
        this.cls.getSingle$('CustomerSupplier'),
        this.cls.getSingle$('CommissionInternalNumberShort'),
        this.cls.getSingle$('CommissionDescription'),
        this.cls.getSingle$('ExecutingDepartment'),
        this.cls.getMultiple$('Department'),
        this.cls.labels$,
    ]).pipe(
        map(([roles, commissionLabels, customerLabel, interneNr, commissionDescription, commissionDepartmentLabel, departmentLabel, customLabels]) => {
            const columns: TableColumnConfig<TableData, CommissionListColumn>[] = [
                { header: interneNr, name: 'InterneNr', width: '7rem' },
                { header: commissionLabels.wordBinding + 'Nr', name: 'AuftragsNr', width: '9rem' },
                { header: 'SchadenNr', name: 'SchadenNr', width: '7rem' },
                { header: 'VersicherungsNr', name: 'VersicherungsNr', width: '' },
                // { header: 'Verantwortlich', name: 'Bearbeiter', width: '7rem' },
                { header: customerLabel, name: 'Auftraggeber', width: '12rem' },
                { header: 'Frist', name: 'LastDeadline', width: '5rem' },
                { header: 'AG', name: 'AbgabeterminAG', width: '5rem' },
                { header: 'Status', name: 'StatusBackoffice', width: '8rem' },
                { header: 'Start', name: 'StartDate', width: '5rem' },
                { header: 'Ende', name: 'EndDate', width: '5rem' },
                { header: 'Adresse', name: 'Address', width: '14rem' },
                { header: commissionLabels.wordBinding + 'typ', name: 'Auftragstyp', width: '8rem' },
                { header: commissionDescription, name: 'Description', width: '14rem' },
                { header: commissionDepartmentLabel, name: 'Department', width: '12rem' },
                { header: departmentLabel, name: 'ChildCommissionDepartments', width: '12rem' },
                { header: 'Unternehmen', name: 'PartnerOffice', width: '12rem' },
                { header: 'Autor', name: 'Author', width: '8rem' },
                { header: 'Erstellt', name: 'CreatedAt', width: '5rem' },
                { header: 'Kommentar', name: 'lastComment', width: '14rem' },
                { header: 'Angebotssumme', name: 'offerSum', width: '10rem', sortDisabled: true },
                { header: customLabels.CommissionFreeTextField1.Nominativ.plural.value, name: 'freeTextField1', width: '10rem' },
                { header: 'Angebotsabgabe', name: 'OfferSubmissionDate', width: '10rem' },
                { header: 'Verhandlung am', name: 'NegotiationAt', width: '10rem' },
                { header: CommissionEntity.EntityPropertyNames.get('CostCenter'), name: 'CostCenter', width: '10rem' },
                { header: customLabels.CommissionCompleteBusinessVolume.Nominativ.singular.value, name: 'CompleteBusinessVolume', width: '10rem' },
            ];
            const selectableColumns = columns.map((c) => c.name);
            const ret = columns.filter((c) => selectableColumns.includes(c.name));
            let indexOfRoles = ret.length;
            const columnsBehindRoles: Array<CommissionListColumn> = ['Auftraggeber', 'LastDeadline', 'AbgabeterminAG', 'StatusBackoffice', 'StartDate', 'EndDate', 'Address', 'Auftragstyp', 'Description', 'Author'];
            ret.forEach((e, i) => {
                if (columnsBehindRoles.includes(e.name)) {
                    indexOfRoles = i;
                }
            });
            return <TableColumnConfig<TableData, CommissionListColumn | string>[]>[
                ...ret.slice(0, indexOfRoles - 1),
                ...roles.map<TableColumnConfig<TableData, CommissionListColumn | string>>((role) => ({
                    header: role.Name,
                    name: CommissionListDataSource.roleKeyPrefix + role.Id,
                    width: '12rem',
                    cell: (rowData: TableData) => rowData.roleCols[CommissionListDataSource.roleKeyPrefix + role.Id],
                })),
                ...ret.slice(indexOfRoles - 1),
            ];
        }),
    );

    selectedColumns$: Observable<Array<CommissionListColumn | string>> = combineLatest([getFetched$(this.store, getSettingFetched, getSetting), getFetched$(this.store, getPartnerFetched, getPartner), this.TableColumns$]).pipe(
        map(([settings, partner, availableColumns]) => {
            const fallback: CommissionListColumn[] = [
                'Auftraggeber',
                'InterneNr',
                'AuftragsNr',
                'Auftragstyp',
                'Address',
                'StartDate',
                'EndDate',
                'AbgabeterminAG',
                'Projektleiter',
                'Author',
                'Vorarbeiter',
                'Sachbearbeiter',
                'LastDeadline',
                'StatusBackoffice',
                'Department',
            ];
            const selectableColumns = availableColumns.map((c) => c.name);
            const displayedColumns = settings.CommissionListComponentDisplayedColumns || partner.AdditionalData?.CommissionListComponentDisplayedColumns || fallback;

            return displayedColumns.filter((c) => selectableColumns.includes(c as CommissionListColumn) || c.startsWith(CommissionListDataSource.roleKeyPrefix)) as CommissionListColumn[];
        }),
        distinctUntilChanged((a, b) => compareArrays(a, b)),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    public TableColumnsSorted$: Observable<TableColumnConfig<TableData, CommissionListColumn | string>[]> = combineLatest([this.selectedColumns$, this.TableColumns$]).pipe(
        map(([selected, tableColumns]) => {
            return tableColumns.sort((a, b) => selected.indexOf(a.name) - selected.indexOf(b.name));
        }),
    );

    displayedColumns$ = combineLatest([this.selectedColumns$, this.TableColumns$, getFetched$(this.store, getSettingFetched, getSetting)]).pipe(
        map(([cols, TableColumns, settings]) => [
            ...cols
                .filter((c) => TableColumns.some((t) => t.name === c))
                .sort((a, b) => {
                    const settingsSort = settings.CommissionListComponentDisplayedColumns || [];
                    const sortBySettings = settingsSort.findIndex((c) => c === a) - settingsSort.findIndex((c) => c === b);
                    if (sortBySettings !== 0) {
                        return sortBySettings;
                    }
                    return TableColumns.findIndex((c) => c.name === a) - TableColumns.findIndex((c) => c.name === b);
                }),
            'chevron',
        ]),
    );

    @ViewChild('wrapperElement') WrapperElement: ElementRef;
    @ViewChild('list') private listComponent: DaveListComponent<TableData>;
    public CommissionIcon = CommissionMeta.Icon;
    public ShowStatus = false;
    public StatusData$: Observable<IDetailListTemplateData>;
    public MultiselectButtons$ = combineLatest([
        this.PS.Has$(this.PS.Permissions.DeleteCommission),
        this.cls.getMultiple$('Commission'),
        this.PS.Has$(this.PS.Permissions.ExportCommissionList),
    ]).pipe(
        map(([canDelete, commissionLabel, hasExportPermission]) => {
            const ret: MultiselectButton<TableData>[] = [];

            if (canDelete) {
                ret.push({
                    tooltip: 'Löschen',
                    icon: 'trash',
                    onClick: (entryIds, event) => this.ClickDelete(entryIds as number[]),
                    color: 'red',
                });
            }

            if (hasExportPermission) {
                ret.push({
                    tooltip: `${commissionLabel} als CSV exportieren`,
                    icon: 'file-csv',
                    onClick: (entryIds) => {
                        this.OpenCommissionCsvExportDialog(entryIds as number[]);
                        return true;
                    },
                });
            }

            return ret;
        }),
    );
    public ReportListFormGroup = new FormGroup({
        Status: new FormControl<number>(null, [Validators.required]),
    });
    public FilterValues$: BehaviorSubject<{
        [FilterTypes.Customers]: number|null;
        [FilterTypes.Editor]: IFilterTypeSearchMultiSelectValue[];
        [FilterTypes.PartnerOfficeId]: IFilterTypeSearchMultiSelectValue[];
        [FilterTypes.Status]: IFilterTypeSearchMultiSelectValue[];
        [FilterTypes.CommissionType]: IFilterTypeSearchMultiSelectValue[];
        [FilterTypes.Departments]: IFilterTypeSearchMultiSelectValue<number>[];
        [FilterTypes.HideSubCommissions]: boolean;
        [FilterTypes.HasRelevantRoleOrIsAssigned]: boolean;
    }> = new BehaviorSubject({
        [FilterTypes.Customers]: null,
        [FilterTypes.Editor]: null,
        [FilterTypes.PartnerOfficeId]: null,
        [FilterTypes.Status]: null,
        [FilterTypes.CommissionType]: null,
        [FilterTypes.Departments]: null,
        [FilterTypes.HideSubCommissions]: null,
        [FilterTypes.HasRelevantRoleOrIsAssigned]: null,
    });

    private onDestroy$ = new Subject<void>();

    public FilterAmount$ = this.FilterValues$.pipe(
        map((val) => {
            let filterAmount = 0;
            for (const [key, value] of Object.entries(val)) {
                if (isArray(value) && value?.length) {
                    filterAmount++;
                }
                if (key === FilterTypes.HideSubCommissions && value) {
                    filterAmount++;
                }
                if (key === FilterTypes.Customers && value !== null) {
                    filterAmount++;
                }
                if (key === FilterTypes.Customers && value !== null) {
                    filterAmount++;
                }
                if (key === FilterTypes.HasRelevantRoleOrIsAssigned && value) {
                    filterAmount++;
                }
            }
            return filterAmount;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    DefaultSortDirection = this.defaultTableSortingService.getSort('commissionList').direction;
    DefaultSortActive = this.defaultTableSortingService.getSort('commissionList').active as keyof TableData;

    protected commentsFetched$ = this.store.select(getCommentFetched);
    protected userToCommissionsMap$ = this.store.select(getUserToCommissions).pipe(
        map(userToCommissions =>
            userToCommissions.reduce((map, u2c) => {
                const list = map.get(u2c.CommissionId) ?? [];
                list.push(u2c);
                map.set(u2c.CommissionId, list);
                return map;
            }, new Map<number, UserToCommissionEntity[]>())
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public length$: BehaviorSubject<number>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    constructor(
        private store: Store<State>,
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
        public PS: PermissionService,
        public LS: LoadingService,
        private defaultFilterService: DefaultFilterService,
        protected cls: CustomLabelService,
        protected defaultTableSortingService: DefaultTableSortingService,
        private commentResolver: CommentResolver,
        // private liResolver: LedgerImportResolver,
        @Inject(LOCALE_ID) private local: string,
        private appGatewayService: AppGatewayService,
        private commissionWizardDialogService: CommissionWizardDialogService,
        private customizationDataService: CustomizationDataService,
        protected customerDataService: CustomerDataService,
        protected ledgerImportDataService: LedgerImportDataService,
    ) {

        // Status von ausgewählten Projekten bei Mehrfachauswahl ändern
                this.subscriptions.push(
                    this.customizationDataService.getFeatures$().pipe(
                        filter(isNotNullOrUndefined),
                        take(1),
                    ).subscribe((features) => {

                        this.subscriptions.push(
                            this.ReportListFormGroup.controls.Status.valueChanges.pipe(
                                distinctUntilChanged(),
                                withLatestFrom(
                                    this.store.select(getStatusFromBackoffice),
                                    this.store.select(getEntityRole),
                                    this.userToCommissionsMap$,
                                    this.store.select(getCommissionDictionary)
                                ),
                            ).subscribe(([value, allStatuses, entityRoles, userToComissionMap, commissionDict]) => {
                                    if (value) {
                                        if(features.includes('kaplCommissionStatus4Dialog') && allStatuses.find((status) => status.Id === value).Name === StatusFromBackofficeNames.KaplStep4 ){
                                            const validCommissionIds = new Map<number, boolean>();;
                                            const BauleiterRole = entityRoles.find((r) => r.Slug === 'Bauleiter');
                                            this.listComponent.MultiselectedEntryIds.forEach((commissionID) => {
                                            const u2c = userToComissionMap.get(+commissionID);

                                                const u2cBauleiter = u2c.find((u) => u.RoleId === BauleiterRole?.Id);
                                                const commission = commissionDict[+commissionID];

                                                if (u2cBauleiter && commission?.StatusBackofficeId !== value && commission?.Kostenstellenart && commission?.DepartmentId){
                                                    this.store.dispatch(
                                                        CommissionActionTypes.ModifyCommission({
                                                            Payload: {
                                                                id: Number(commissionID),
                                                                statusBackofficeId: value,
                                                            },
                                                        })
                                                    );
                                                }else if(commission?.StatusBackofficeId !== value){
                                                    validCommissionIds.set(Number(commissionID), !!u2cBauleiter);
                                                }
                                            });
                                            if(validCommissionIds.size > 0){
                                                const commissionIdsArray = Array.from(validCommissionIds.keys());
                                                this.dialog
                                                    .open<KaplStatus4DialogComponent, MissingCommissionValuesDialogData, MissingCommissionValuesResult>(
                                                        KaplStatus4DialogComponent,
                                                        {
                                                            data: {
                                                                CommissionIds: commissionIdsArray,
                                                                BauleiterRoleId: BauleiterRole?.Id,
                                                            },
                                                        },
                                                    )
                                                    .afterClosed()
                                                    .subscribe((result) => {
                                                        if(!result){
                                                            this.ReportListFormGroup.controls.Status.reset()
                                                          //  this.dialog.closeAll()
                                                            return
                                                        }
                                                        commissionIdsArray.forEach((commissionId) => {
                                                            const currentres = result[commissionId]

                                                            if(!validCommissionIds.get(commissionId)){
                                                                this.store.dispatch(
                                                                    UserToCommissionActionTypes.Create({
                                                                        Payload: {
                                                                            userId: currentres.BauleiterUserId,
                                                                            commissionId: commissionId,
                                                                            roleId: BauleiterRole.Id,
                                                                        },
                                                                    }),
                                                                );
                                                            }
                                                            this.store.dispatch(
                                                                CommissionActionTypes.ModifyCommission({
                                                                    Payload: {
                                                                        id: commissionId,
                                                                        statusBackofficeId: value,
                                                                        departmentId: result[commissionId].DepartmentId,
                                                                        kostenstellenart: result[commissionId].Kostenstellenart,
                                                                    },
                                                                })
                                                            );


                                                        });
                                                        return
                                                    });
                                                return
                                            }
                                            }

                                        this.ShowStatus = false;

                                        this.listComponent.MultiselectedEntryIds.forEach((commissionID) => {
                                            this.store.dispatch(
                                                CommissionActionTypes.ModifyCommission({
                                                    Payload: {
                                                        id: Number(commissionID),
                                                        statusBackofficeId: value,
                                                    },
                                                })
                                            );
                                        });

                                        this.listComponent?.ToggleMultiselect();
                                    }
                                })
                        );
                    })
                );

                // saving filter settings in store
        this.FilterValues$.pipe(takeUntil(this.onDestroy$), skip(2)).subscribe((val) => {
            if (Object.keys(val).length !== 0) {
                this.defaultFilterService.SetFilterByApp(FilterApps.CommissionList, val);
            }
        });
    }




    ngAfterViewInit(): void {
        this.datasource = new CommissionListDataSource(this.store, this.cls, this.customerDataService, this.local, this.commentResolver, this.FilterValues$, this.ledgerImportDataService);
        this.length$ = this.datasource.length$
        this.DataSource$ = of(this.datasource);
        this.afterViewInit$.next();
        this.activatedRoute.queryParams.pipe(first()).subscribe((params) => {
            const customerId = params['customerId'];
            if (customerId) {
                this.setCustomerFilter(+customerId);
            }
        });
        this.datasource.marSort = this.listComponent.sort
        this.datasource.matPaginator = this.paginator
        // Anzeige von Status in Mehrfachauswahl
        this.StatusData$ = this.listComponent.MultiselectedEntryIdsChange.pipe(
            startWith(null),
            map(() => this.listComponent.MultiselectedEntryIds),
            withLatestFrom(this.store.select(getStatusFromBackoffice)),
            map(([commissionIDs, status]) => {
                let selectedStatusIds = [];
                commissionIDs.forEach((cId) =>
                    this.store
                        .select(getCommissionById({ id: Number(cId) }))
                        .subscribe((c) =>
                            this.store
                                .select(getCommissionTypeById({ id: c.CommissionTypeId }))
                                .subscribe((ct) =>
                                    isNotNullOrUndefined(ct.StatusBackofficeIds) ? ct.StatusBackofficeIds.forEach((s) => (isNotNullOrUndefined(s) && !selectedStatusIds.includes(s) ? selectedStatusIds.push(s) : null)) : null,
                                ),
                        ),
                );
                if (selectedStatusIds.length > 0) {
                    status = status.filter((state) => selectedStatusIds.map((filter) => filter).includes(state.Id));
                }
                return {
                    Properties: [
                        {
                            key: 'Status',
                            formControl: this.ReportListFormGroup.controls.Status,
                            options: {
                                specialInput: {
                                    select: status.map((b) => ({
                                        optionLabel: b.Name,
                                        optionValue: b.Id,
                                    })),
                                },
                            },
                        },
                    ],
                };
            }),
        );
    }
    public OpenDemo() {
        this.dialog.open(PieceworkDemoComponent, {
            ...PieceworkDemoComponent.DefaultConfig,
        });
    }

    async setCustomerFilter(customerId: number): Promise<void> {
        const currentFilters = this.FilterValues$.getValue();
        this.FilterValues$.next({
            ...currentFilters,
            [FilterTypes.Customers]: customerId
        });
    }

    ngOnInit(): void {

        this.defaultFilterService.GetFilterByApp$(FilterApps.CommissionList)
            .pipe(take(1))
            .subscribe(filterValues => {
                //convert array to null or number
                let customer = filterValues[FilterTypes.Customers]
                if (isArray(customer)) {
                    if (customer.length === 0) {
                        customer = null;
                    } else {
                        customer = customer[0];
                    }
                }
                this.FilterValues$.next({
                    [FilterTypes.Customers]: customer,
                    [FilterTypes.Editor]: filterValues[FilterTypes.Editor] && isArray(filterValues[FilterTypes.Editor]) ? (filterValues[FilterTypes.Editor] as IFilterTypeSearchMultiSelectValue[]) : [],
                    [FilterTypes.PartnerOfficeId]: filterValues[FilterTypes.PartnerOfficeId] && isArray(filterValues[FilterTypes.PartnerOfficeId]) ? (filterValues[FilterTypes.PartnerOfficeId] as IFilterTypeSearchMultiSelectValue[]) : [],
                    [FilterTypes.Status]: filterValues[FilterTypes.Status] && isArray(filterValues[FilterTypes.Status]) ? (filterValues[FilterTypes.Status] as IFilterTypeSearchMultiSelectValue[]) : [],
                    [FilterTypes.CommissionType]: filterValues[FilterTypes.CommissionType] && isArray(filterValues[FilterTypes.CommissionType]) ? (filterValues[FilterTypes.CommissionType] as IFilterTypeSearchMultiSelectValue[]) : [],
                    [FilterTypes.Departments]: filterValues[FilterTypes.Departments] && isArray(filterValues[FilterTypes.Departments]) ? (filterValues[FilterTypes.Departments] as IFilterTypeSearchMultiSelectValue<number>[]) : [],
                    [FilterTypes.HideSubCommissions]: isNotNullOrUndefined(filterValues[FilterTypes.HideSubCommissions]) ? filterValues[FilterTypes.HideSubCommissions] : false,
                    [FilterTypes.HasRelevantRoleOrIsAssigned]: isNotNullOrUndefined(filterValues[FilterTypes.HasRelevantRoleOrIsAssigned]) ? filterValues[FilterTypes.HasRelevantRoleOrIsAssigned] : false,
                });
            });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public CsvDownload() {
        this.dialog.open(CommissionDownloadComponent, {
            width: '500px',
        });
    }

    public CreateCommission() {
        firstValueFrom(
            this.store.select(getPartner).pipe(
                switchMap((partner) =>
                    (partner.PartnerTypeId === PartnerTypeEnum.TSB
                        ? this.store.select(getCommissionTypes).pipe(
                            map((cts) => ({
                                partner,
                                commissionType: cts.find((ct) => ct.AdditionalData?.IsDefault),
                            })),
                        )
                        : of({
                            partner,
                            commissionType: null,
                        }))
                ),
            ),
        ).then(({ partner, commissionType }) => {

            if (!partner.Settings?.WizardSteps) {
                this.dialog.open<NewCommissionDialogComponent, NewCommissionDialogComponentDialogData>(NewCommissionDialogComponent, {
                    ...NewCommissionDialogComponent.DefaultConfig,
                    data: {
                        CreateCommissionPayload: {
                            customerId: this.FilterValues$.value[FilterTypes.Customers],
                            auftragseingangDurchAuftraggeber: new Date().toDateString(),
                        },
                        NavigateRelativeTo: this.activatedRoute,
                        ForceCommissionTypeId: commissionType?.Id,
                    },
                });
            }else{
                this.commissionWizardDialogService.OpenDialog(null, partner.Settings.WizardSteps);
            }
        });
    }

    selectedColumnsChange(selectedColumns: Array<keyof TableData>) {
        this.store.dispatch(
            new ChangeSettings({
                CommissionListComponentDisplayedColumns: selectedColumns,
            }),
        );
    }
    disabledColumns$ = combineLatest([this.TableColumnsSorted$, this.selectedColumns$]).pipe(map(([all, selected]) => all.length - selected.length || undefined));
    protected readonly CommentIcon = CommentIcon;

    onCommentClick(commissionId: number) {
        this.dialog.open<CommentListDialogComponent, CommentListDialogComponentDialogData>(CommentListDialogComponent, {
            ...CommentListDialogComponent.DefaultConfig,
            data: {
                entityType: CommentEntityTypeEnum.Commission,
                entityId: commissionId,
            },
        });
    }

    public OpenUserSelect(commissionId: number) {
        this.dialog.open<SelectUserCommissionDialogComponent, SelectUserCommissionDialogComponentDialogData>(SelectUserCommissionDialogComponent, {
            ...SelectUserCommissionDialogComponent.DefaultConfig,
            data: {
                commissionId: commissionId,
                hideStartDate: true,
            },
        });
    }

    // Projekte in Mehrfachauswahl löschen
    ClickDelete(ids: number[]) {
        if (!ids || !ids.length) {
            return false;
        }
        return firstValueFrom(
            this.dialog
                .open<AppConfirmationDialogComponent, AppConfirmationDialogData>(AppConfirmationDialogComponent, {
                    data: {
                        paragraph: 'Ausgewählte Projekte wirklich löschen?',
                        styleDelete: true,
                    },
                })
                .afterClosed(),
        ).then(([res]) => {
            if (res) {
                ids.map((r: number) => {
                    this.store.dispatch(CommissionActionTypes.DeleteCommission({ Payload: r }));
                });
            }
            return !!res;
        });
    }

    public OpenCommissionCsvExportDialog(commissionIds: number[]) {
        this.dialog
            .open<CommissionCsvExportDialogComponent, CommissionCsvExportDialogData, CommissionCsvExportDialogReturnData>(CommissionCsvExportDialogComponent, {
                ...CommissionCsvExportDialogComponent.DefaultConfig,
            })
            .afterClosed()
            .subscribe(async (result) => {
                if (!result) {
                    return;
                }
               this.LS.startLoading('CommissionListComponent_OpenCommissionCsvExportDialog', {dialogMessage: 'Csv wird erstellt'})

                this.appGatewayService
                    .Request({
                        CommissionExportCommissionsAsCSV: {
                            FromDate: result.FromDate ? GetTimestampFromTime(result.FromDate.toDate()).toString() : undefined,
                            ToDate: result.ToDate ? GetTimestampFromTime(result.ToDate.toDate()).toString() : undefined,
                            CommissionIds: commissionIds.map((c) => c.toString()),
                        },
                    })
                    .then((response) => {
                        const documentId = Number(response.CommissionExportCommissionsAsCSV.DocumentId);
                        console.log('Response:', response);
                        this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
                            ...DaveFilePreviewComponent.DefaultConfig,
                            data: {
                                fileId: documentId,
                            },
                        });
                    })
                    .finally(() => {
                        this.LS.endLoading('CommissionListComponent_OpenCommissionCsvExportDialog');
                    });
            });
    }

    protected onSortChange($event: Sort) {
        this.defaultTableSortingService.setSort('commissionList', $event);
        // this.datasource.sort.sort()
    }
    protected onSearchChange($event: string) {
        this.datasource.searchQuery$.next($event);
        this.datasource.matPaginator.firstPage();
        // this.datasource.sort.sort()
    }
}
